import React from "react";
import { useTranslation } from "react-i18next";
import { SelfReadingStatus } from "../../enums/selfReadingStatus";

interface Props {
  status: SelfReadingStatus;
}

const SelfReadingStatusLabel = ({ status }: Props) => {
  const { t } = useTranslation(["contracts\\enums\\selfReadingStatus"]);

  switch (status) {
    case SelfReadingStatus.Created:
      return (
        <span className="badge badge-pill badge-info small font-weight-normal text-truncate mw-100 text-white">
          {t(status)}
        </span>
      );
    case SelfReadingStatus.SentToDistributor:
      return (
        <span className="badge badge-pill badge-warning small font-weight-normal text-truncate mw-100">
          {t(status)}
        </span>
      );
    case SelfReadingStatus.Approved:
      return (
        <span className="badge badge-success badge-success small font-weight-normal text-truncate mw-100">
          {t(status)}
        </span>
      );
    case SelfReadingStatus.Rejected:
      return (
        <span className="badge badge-pill badge-danger small font-weight-normal text-truncate mw-100">
          {t(status)}
        </span>
      );
    case SelfReadingStatus.Canceled:
      return (
        <span className="badge badge-pill badge-danger small font-weight-normal text-truncate mw-100">
          {t(status)}
        </span>
      );
    default:
      return null;
  }
};

export default SelfReadingStatusLabel;
